export default "__VITE_ASSET__BUpAWt0j__"